import React, { useEffect } from "react";
import Link from "next/link";
import Head from "next/head";
import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import BlogImage from "components/customImages/BlogImage";
import { getCurrentPath, getOrigin } from "utils/common";
import Button from "components/ui_components/button";
import { BASE_URL } from "helpers/constants/routes";

function Index() {
  const router = useRouter();
  const { locale } = router;

  useEffect(() => {
    document.documentElement.dir = "ltr";
  }, [locale]);
  const origin = getOrigin();
  const currentPath = getCurrentPath();

  return (
    <>
      <Head>
        <title>{" Les Meilleures Maisons d'Hôtes en Tunisie | Yawakit"}</title>
        <meta
          name="description"
          content=" Découvrez notre sélection des meilleures maisons d'hôtes en Tunisie. Profitez d'un séjour authentique et confortable dans des lieux uniques à travers le pays."
        />
        <link rel="alternate" hrefLang="fr" href={`${origin}${currentPath}`} />
        <link rel="alternate" hrefLang="ar" href={`${origin}/ar${currentPath}`} />
      </Head>
      <div className="flex flex-col  w-full py-10 justify-center">
        <div className="max-w-[680px] m-auto px-6">
          <h1 className="font-bold text-md lg:text-lg  mb-10 text-center ">{`Les meilleures maisons d'hôtes en Tunisie`}</h1>
          <time dateTime="02-04-2025">Avril 02, 2025</time>
          <p>
            {`À la recherche d'une`}{" "}
            <span className="font-bold"> {`maison d'hôtes en Tunisie`}</span>{" "}
            {`où chaque moment se transforme en une expérience immersive dans un cadre enchanteur ? Une maison nichée au cœur des montagnes de, où vous pourrez vous ressourcer dans un environnement entièrement végétal, enveloppé par la nature luxuriante ? Ou une immersion authentique dans le sud tunisien, dans des chambres en bois, élégamment aménagées au cœur d'une oasis ? Découvrez notre sélection des`}{" "}
            <span className="font-bold"> {`meilleures maisons d'hôtes en Tunisie. `}</span>
          </p>
          <div className="flex justify-center p-5">
            <BlogImage
              imageName="1b7d419b-0758-4c23-a3ee-daf491f8513e.jpg"
              alt="GestHouse Tunisia"
              className="object-contain"
              imageUrl="1b7d419b-0758-4c23-a3ee-daf491f8513e.jpg"
            />
          </div>
          {/*  -------- First section ----------- */}
          <h2 className="font-bold text-md lg:text-lg mx-5">{`Maisons d’hôtes à La Médina de Tunis `}</h2>
          <h3 className="font-bold text-md lg:text-lg mx-5">{`1. El Patio Courtyard à La Médina de Tunis  `}</h3>

          <p>
            {`Cette maison d’hôte au cœur de la Médina de Tunis offre aux visiteurs une expérience culturelle unique dans une ambiance exceptionnelle qui se traduit par un voyage dans le temps.`}
          </p>

          {/*----------- Second section ---------- */}
          <h3 className="font-bold text-md lg:text-lg m-5">{`2. Dar Zyne à La Médina de Tunis`}</h3>
          <p>
            {`Nichée au cœur de la Médina, cette maison d’hôtes exceptionnelle qui date du 16ème siècle représente un vrai bijou architectural. L’harmonie des couleurs et l’élégance bourgeoise éblouissent les yeux dès la première entrée.   `}{" "}
          </p>
          <br />
          <h2 className="font-bold text-md lg:text-lg mx-5">
            {" "}
            {`Les maisons d'hôtes du Nord de la Tunisie`}{" "}
          </h2>
          <h3 className="font-bold text-md lg:text-lg mx-5">{`1. Dar El Lamma à Ras Jbel`}</h3>
          <p>{`C’est une superbe maison d'hôtes qui se situe à Ras Jebel du gouvernorat de Bizerte. Son architecture est inspirée des styles Berbères et Andalous... Un mélange stupéfiant qui vous fait voyager dans le temps.`}</p>
          <div className="flex justify-center m-8">
            <Button>
              <Link
                target="_blank"
                rel="noopener"
                href={`${BASE_URL}categories/loisir/facebook-dar-el-lamma`}
                passHref
                legacyBehavior
              >
                {`Plus d'informations sur Dar El Lamma`}
              </Link>
            </Button>
          </div>
          <h2 className="font-bold text-md lg:text-lg m-5">{`2. Les jardins de la Mer au cœur de Ghar El Melh`}</h2>
          <p>
            {`Nichée dans la montagne de Ghar El Melh avec une vue panoramique sur la mer méditerranéenne, cette`}
            <a
              href={`${BASE_URL}categories/loisir/facebook-les-jardins-de-la-mer-ghar-el-melh`}
              className=" underline text-blue visited:text-[#0369a1] hover:underline"
            >
              {" "}
              maison d’hôte les jardins de la mer{" "}
            </a>
            {` est l’emplacement idéal pour ceux qui cherchent à passer des moments de calme.
            `}{" "}
          </p>
          <h3 className="mx-5"> {`3. Villa Edo à Gammarth `} </h3>
          <p>
            {`Située au niveau de la colline de Gammarth, fenêtre ouverte sur la Méditerranée, Villa Edo propose des suites spacieuses, un jardin splendide et exceptionnel.`}
          </p>
          <div className="flex justify-center p-5">
            <BlogImage
              imageName="542250991.jpg"
              alt="Villa Edo à Gammarth"
              className="object-contain"
              imageUrl="542250991.jpg"
            />
          </div>

          <h3 className="mx-5"> {`4. Maison Dedine à Sidi Bou Said`} </h3>
          <p>{`C’est une maison merveilleuse qui reflète la beauté du village de Sidi Bou Said. Maison Dedine se caractérise par son style architectural moderne et son atmosphère paisible et qui vous permet de profiter d’un excellent séjour mémorable.`}</p>

          <h2 className="mx-5">{`Les maisons d'hôtes situées au Cap-Bon`}</h2>
          <h3 className="mx-5">{`1. Dar Jbel à Bir Bou Regba`}</h3>
          <p>{`Dar Jbel propose un environnement paisible et tranquille dans la campagne de Hammamet. Cette magnifique villa de rêve vous permettra d'explorer un autre aspect de la région.`}</p>
          <h3 className="mx-5">{`2. Dar R’bat à Nabeul`}</h3>
          <p>
            {`Située dans un ancien quartier à Nabeul, cette demeure d'hôtes traditionnelle vous permet d’explorer une Tunisie intérieure, à proximité de la vie Tunisienne. `}
          </p>
          <div className="flex justify-center m-8">
            <Button>
              <Link
                target="_blank"
                rel="noopener"
                href={`${BASE_URL}categories/loisir/facebook-dar-r-bat-maison-d-hotes-nabeul`}
                passHref
                legacyBehavior
              >
                {`Découvrez Dar R'bat`}
              </Link>
            </Button>
          </div>
          <h3 className="mx-5">{`3. Villa Verde à Hammamet`}</h3>
          <p>{`La Maison de Nature et de Bonheur est bien plus qu'une simple Maison d'hôtes, elle vous accueille et vous propose un moment de calme total.`}</p>
          <div className="flex justify-center p-5">
            <BlogImage
              imageName="476244890_1033862085448841_4188831051891787438_n.jpg"
              alt="Villa Verde à Hammamet"
              className="object-contain"
              imageUrl="476244890_1033862085448841_4188831051891787438_n.jpg"
            />
          </div>
          <h3 className="mx-5">{`4. Borj Waly à Zaghouane`}</h3>
          <p>{`Dar V Borj Waly, un endroit merveilleux où vous pourrez vivre une expérience d'un séjour remarquable, un havre de tranquillité et de convivialité.`}</p>
          <h3 className="mx-5">{`5. Villa Zembra à El Haouaria`}</h3>
          <p>{`Située idéalement face aux îles Zembra, cette maison d'hôte constitue une excellente option pour profiter d'un moment de tranquillité et de bien-être. 
Durant votre séjour, vous avez la possibilité de vous divertir grâce aux diverses activités offertes par les propriétaires de la maison. `}</p>
          <div className="flex justify-center p-5">
            <BlogImage
              imageName="301962876.jpg"
              alt="Villa Zembra à El Haouaria"
              className="object-contain"
              imageUrl="301962876.jpg"
            />
          </div>
          <h2 className="mx-5">{`Les maisons d'hôtes au Nord-Ouest de la Tunisie`}</h2>
          <h3 className="mx-5">{`1. Le Verger à Kef`}</h3>
          <p>{`Cette maison d’hôte vous propose toutes les caractéristiques d'un séjour hors du temps : la tranquillité dont vous avez tant rêvé, ainsi qu'une maison charmante avec toutes les commodités nécessaires : piscine privée, espace barbecue, etc.`}</p>
          <div className="flex justify-center p-5">
            <BlogImage
              imageName="wildyness-zaafrana-le-verger-5.jpg"
              alt="Le Verger à Kef"
              className="object-contain"
              imageUrl="wildyness-zaafrana-le-verger-5.jpg"
            />
          </div>
          <h3 className="mx-5">{`2. Couleur Méditerranée à Tabarka`}</h3>
          <p>{`Cette maison d'hôtes est située à Tabarka, sur une falaise, offrant une vue époustouflante sur la Méditerranée avec ses mille reflets. `}</p>
          <div className="flex justify-center p-5">
            <BlogImage
              imageName="1505818338.jpg"
              alt="Couleur Méditerranée à Tabarka"
              className="object-contain"
              imageUrl="1505818338.jpg"
            />
          </div>
          <h3 className="mx-5">{`3. La Verrière à Ain Draham`}</h3>
          <p>{`La Verrière se situe au sommet de la montagne, dominant une magnifique vallée qui s'étend jusqu'à la mer de Tabarka.`}</p>
          <div className="flex justify-center p-5">
            <BlogImage
              imageName="tia4jmyi3668o09mav5h.jpeg"
              alt="La Verrière à Ain Draham"
              className="object-contain"
              imageUrl="tia4jmyi3668o09mav5h.jpeg"
            />
          </div>
          <h2 className="mx-5">{`Les maisons d'hôtes à Sousse et Monastir`}</h2>
          <h3 className="mx-5">{`1. Dar Benti à Monastir`}</h3>
          <p>{`Proposez-vous une immersion totale dans ce petit bijou paisible, propre et accueillant. Un environnement paradisiaque, authentique et empreint d'histoire avec une note d'élégance et de sophistication.`}</p>
          <h3 className="mx-5">{`2. Dar Antonia à Sousse`}</h3>
          <p>
            {" "}
            {`La décoration de cette maison est magnifique et la terrasse qui donne sur les toits de la Médina est inoubliable. Les chambres sont grandes, agréables et impeccablement aménagées.`}
          </p>
          <div className="flex justify-center p-5">
            <BlogImage
              imageName="302667569.jpg"
              alt="Dar Antonia à Sousse"
              className="object-contain"
              imageUrl="302667569.jpg"
            />
          </div>
          <h2>{`Les maisons d'hôtes au Sud de la Tunisie`}</h2>
          <h3 className="mx-5">{`1. Ksar Ouled Debbab à Tataouines`}</h3>
          <p>
            {" "}
            <a
              href={`${BASE_URL}categories/loisir/facebook-ksar-ouled-debbab`}
              className=" underline text-blue visited:text-[#0369a1] hover:underline"
            >
              {`Ksar Ouled Debbab`}
            </a>{" "}
            {` est un hôtel charmant, un musée et un restaurant qui se présentent sous la forme de « Ksours » constitués d'un ensemble de « Ghorfas ». 
À l'époque, il s'agissait d'un grenier traditionnel pour le grain.`}
          </p>
          <h3>{`2. L’auberge de Tamezret à Tamezret`}</h3>
          <p>{`Avec son architecture traditionnelle locale et ses éléments simples mais exclusifs, l'Auberge de Tamezret propose un confort exceptionnel. Il s'agit d'une adresse originale qui vous offrira une expérience singulière et authentique au sud de la Tunisie.`}</p>
          <h3>{`3. Diar Abou Habibi à Tozeur`}</h3>
          <p>
            {`Vous serez hébergé dans un environnement paisible et paisible pour vous assurer un véritable dépaysement. Cette maison d'hôte offre des paysages splendides où vous pourrez découvrir et vous détendre. `}{" "}
            <a
              href={`${BASE_URL}categories/loisir/instagram-diar-abou-habibi`}
              className=" underline text-blue visited:text-[#0369a1] hover:underline"
            >{`Diar Abou Habibi `}</a>{" "}
            {`est le lieu parfait pour les personnes à la recherche de sérénité, mais également un excellent choix pour une escapade entre amis ou un weekend romantique en couple.`}
          </p>
          <div className="flex justify-center p-5">
            <BlogImage
              imageName="44468807_2066765720229704_1877670310656868352_n.jpg"
              alt="Maison d’hôte Diar Abou Habibi à Tozeur"
              className="object-contain"
              imageUrl="44468807_2066765720229704_1877670310656868352_n.jpg"
            />
          </div>
          <p>
            {`Explorez notre sélection exclusive de `}{" "}
            <span className="font-bold">{`maisons d'hôtes en Tunisie. `} </span>
            {` Plongez dans l’authenticité tunisienne :`}
          </p>
          <div className="flex justify-center m-8">
            <Button>
              <Link
                target="_blank"
                rel="noopener"
                href={`${BASE_URL}categories/loisir?extraOptions=%7B%22sub_category%22%3A%7B%22name%22%3A%7B%22containsi%22%3A%22Loi+%3E+Maisons+d%27h%C3%B4tes%22%7D%7D%7D`}
                passHref
                legacyBehavior
              >
                {`Trouvez la maison d'hôte idéale pour des vacances innoubliables en Tunisie`}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["layout", "categories", "signup_promotion"])),
    },
  };
}

export default Index;
